import { Dialog, Box, Typography, IconButton, Grid } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import useOrderDetailController from "./controller/orderDetailController";
import { OrderModel } from "../../models/order";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "../../components/ConfirmDialog";
import PackOrder from "./PackOrder";
import ConfirmCancelOrderDialog from "../../components/ConfirmCancelOrderDialog";
import OrderList from "./components/CardShowProduct";
import CardCustomer from "./components/CardCustomer";
import ActionButton from "./components/ActionButton";

interface Props {
    selectedData: OrderModel;
    onClose: VoidFunction;
    onRefetchData: () => Promise<void>;
}
const OrderForm = ({ selectedData, onClose, onRefetchData }: Props) => {
    const controller = useOrderDetailController({
        selectedData,
        onClose,
        onRefetchData
    });
    const { t } = useTranslation("global");
    if (controller.isPacking) return <PackOrder oriCarts={selectedData?.carts} onCloseFormDetail={onClose} onClose={controller.handleCloseIsPacking} selectedData={selectedData} onRefetchData={onRefetchData} />
    return <>
        <Dialog
            fullWidth
            maxWidth={'lg'}
            open={selectedData ? true : false}
            PaperProps={{ sx: { borderRadius: "15px" } }}
        >
            <Box sx={{ overflow: 'auto', height: '100vh', background: "#F3FAFE", padding: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography color="#616161" fontSize="24px" sx={{ mb: 1 }}>{t("order_page.Customer detail")}</Typography>
                    <Typography color="#616161" fontSize="24px" sx={{ mt: 1, mb: 1 }}>{t("order_page.Order detail")}</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon sx={{ fontSize: 15 }} />
                    </IconButton>
                </Box>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <CardCustomer selectedData={selectedData} />
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <OrderList selectedData={selectedData} />
                            <ActionButton
                                selectedData={selectedData}
                                onOpenDeclineConfirmDialog={controller.handleOpenDeclineConfirmDialog}
                                onOpenConfirmDialog={controller.handleOpenConfirmDialog}
                                onOpenIsPacking={controller.handleOpenIsPacking}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <ConfirmDialog
                open={controller.openConfirmDialog}
                title={t("order_page.Do you want to pack this order?")}
                loading={controller.loadingConfirmDialog}
                onCancel={controller.handleCloseConfirmDialog}
                onConfirm={controller.handleAcceptOrder}
            />
            <ConfirmCancelOrderDialog
                open={controller.openConfirmDeclineDialog}
                title={t("order_page.Do you want to decline this order?")}
                loading={controller.loadingConfirmDeclineDialog}
                onCancel={controller.handleCloseDeclineConfirmDialog}
                onConfirm={controller.handleDeclineConfirmDialog}
            />
        </Dialog>
    </>
}
export default OrderForm;